var DetailTableIgCheckController = (function () {
    function DetailTableIgCheckController(topic, settings, socket, $injector, env, $timeout, $scope, $attrs) {
        var _this = this;
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.$injector = $injector;
        this.env = env;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$attrs = $attrs;
        this.comp = ['goe_data', 'cmr'];
        this.socket.forward('topic.search.result', this.$scope);
        this.$scope.$on('socket:topic.search.result', function (event, data) {
            _this.processing = false;
        });
        // IF YOU CHANGE ANY OF THESE VALUES, PLEASE CHANGE IT ALSO IN TEH ELIGIBILITY.TS in prepareFuzzyObject  function!!!!
        this.errorCheckerInput = false;
        this.filterDisplay = false;
        this.displayFindGoe = false;
        this.displayFindCmr = false;
        this.tableName = 'Incentives Government Check';
        this.visible = false;
        this.expand = false;
    }
    DetailTableIgCheckController.prototype.toggle = function () {
        this.visible = !this.visible;
        this.tableName = 'Incentives Government Check';
    };
    DetailTableIgCheckController.prototype.toggleFilter = function () {
        this.filterDisplay = !this.filterDisplay;
    };
    DetailTableIgCheckController.prototype.getManualGoeDecisionLabel = function () {
        if (this.topic.topic.commonGOEDecision) {
            switch (this.topic.topic.commonGOEDecision.goeDecision) {
                case 'Y': return 'Government Entity';
                case 'S': return 'State Owned Enterprise';
                case 'N': return 'Non-government';
                case 'U': return 'Unknown';
                default: return '';
            }
        }
    };
    DetailTableIgCheckController.prototype.getManualGoeReasonLabel = function () {
        if (this.topic.topic.commonGOEDecision) {
            var duns = void 0;
            var trusted = void 0;
            switch (this.topic.topic.commonGOEDecision.reason) {
                case 'TRUSTED_WITH_DUNS': {
                    duns = '';
                    trusted = '';
                    break;
                }
                case 'TRUSTED_WITHOUT_DUNS': {
                    duns = 'no ';
                    trusted = '';
                    break;
                }
                case 'NOT_TRUSTED_WITH_DUNS': {
                    duns = '';
                    trusted = 'not ';
                    break;
                }
                case 'NOT_TRUSTED_WITHOUT_DUNS': {
                    duns = 'no ';
                    trusted = 'not ';
                    break;
                }
                default: {
                    return this.topic.topic.commonGOEDecision.reason || 'no records';
                }
            }
            var message = void 0;
            if (this.topic.topic.commonGOEDecision.reason === 'EMPTY_RESULTS') {
                message = 'no records';
            }
            else {
                message = duns + "DUNS - " + trusted + "Most Trusted Source";
            }
            switch (this.topic.topic.commonGOEDecision.goeDecision) {
                case 'Y': return "Yes - " + message;
                case 'N': return "No - " + message;
                case 'U': return "Unknown - " + message;
                default: return '';
            }
        }
    };
    DetailTableIgCheckController.prototype.toggleSearchInput = function (searchType) {
        if (searchType === 'findGoe') {
            this.displayFindGoe = !this.displayFindGoe;
            this.displayFindCmr = false;
            this.tableName = 'Incentives Government Check';
        }
        if (searchType === 'findCmr') {
            this.displayFindCmr = !this.displayFindCmr;
            this.displayFindGoe = false;
            this.tableName = 'Find Cmr';
        }
    };
    DetailTableIgCheckController.$inject = ['topic', 'settings', 'socket', '$injector', 'env', '$timeout', '$scope', '$attrs'];
    return DetailTableIgCheckController;
}());
var DetailTableIgCheckComponent = (function () {
    function DetailTableIgCheckComponent() {
        this.templateUrl = 'detail-table-igcheck.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableIgCheckController;
    }
    return DetailTableIgCheckComponent;
}());
angular
    .module('application')
    .component('detailTableIgCheck', new DetailTableIgCheckComponent());

//# sourceMappingURL=detail.table.igcheck.component.js.map
